import React from 'react';

export default function Security() {
  return (
    <svg
      width='32'
      height='32'
      viewBox='0 0 32 32'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M0 16C0 7.16344 7.16344 0 16 0C24.8366 0 32 7.16344 32 16C32 24.8366 24.8366 32 16 32C7.16344 32 0 24.8366 0 16Z'
        fill='#27272A'
      />
      <path
        d='M16.0003 22.6666C16.0003 22.6666 21.3337 20 21.3337 16V11.3333L16.0003 9.33331L10.667 11.3333V16C10.667 20 16.0003 22.6666 16.0003 22.6666Z'
        stroke='#A1A1AA'
        strokeWidth='1.25'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
}
